import React from 'react';
import styled from 'styled-components';

const ContentSection = styled.section`
  padding: 60px 0;
`;

const ContentContainer = styled.div`
  display: flex;
  gap: 50px;
  align-items: center;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    flex-direction: column;
  }
`;

const TextContent = styled.div`
  flex: 1;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    order: 2;
  }
`;

const Title = styled.h2`
  font-size: ${props => props.theme.fontSizes.xxlarge};
  margin-bottom: 20px;
  color: ${props => props.theme.colors.secondaryColor};
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.fontSizes.xlarge};
  }
`;

const Paragraph = styled.p`
  margin-bottom: 20px;
  color: ${props => props.theme.colors.grey[600]};
  line-height: 1.8;
  font-size: ${props => props.theme.fontSizes.regular};
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const ImageContainer = styled.div`
  flex: 1;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    order: 1;
    margin-bottom: 30px;
  }
  
  img {
    width: 100%;
    height: auto;
    border-radius: ${props => props.theme.borders.radius.regular};
    box-shadow: ${props => props.theme.shadows.regular};
  }
`;

const AboutContent = () => {
  return (
    <ContentSection>
      <div className="container">
        <ContentContainer>
          <TextContent>
            <Title>Our Story</Title>
            <Paragraph>
              KALS Academy was established with a vision to provide quality education in structural engineering and design. 
              Founded by C. Kalyanasundaram, a veteran in the field with extensive experience in the Public Works Department, 
              the academy aims to bridge the gap between theoretical knowledge and practical application.
            </Paragraph>
            <Paragraph>
              Over the years, we have grown into a premier institution offering specialized training programs for engineering 
              students, professionals, and aspirants preparing for competitive examinations.
            </Paragraph>
            <Paragraph>
              Our focus on excellence, innovation, and practical training has helped numerous students achieve their career 
              goals and excel in their professional lives.
            </Paragraph>
          </TextContent>
          
          <ImageContainer>
            <img src="/placeholder/500/300" alt="KALS Academy Building" />
          </ImageContainer>
        </ContentContainer>
      </div>
    </ContentSection>
  );
};

export default AboutContent;
